package com.havn.app.core.localization

import com.havn.app.core.navigation.HavnDestination

fun HavnDestination.localizedTitle(strings: HavnStrings): String = when (this) {
    HavnDestination.Auth -> strings.navAuth
    HavnDestination.Dashboard -> strings.navToday
    HavnDestination.Properties -> strings.navProperties
    HavnDestination.OpenHouses -> strings.navOpenHouses
    HavnDestination.Clients -> strings.clientsTitle
    HavnDestination.Leads -> strings.navLeads
    HavnDestination.FollowUps -> strings.navFollowUps
    HavnDestination.Reports -> strings.navReports
    HavnDestination.Tasks -> "Tasks"
    HavnDestination.Analytics -> "Analytics"
    HavnDestination.Agency -> "Agency"
    HavnDestination.Settings -> strings.navSettings
}

fun HavnDestination.localizedShortLabel(strings: HavnStrings): String = when (this) {
    HavnDestination.Auth -> strings.navAuth
    HavnDestination.Dashboard -> strings.navToday
    HavnDestination.Properties -> strings.navProperties
    HavnDestination.OpenHouses -> strings.navTours
    HavnDestination.Clients -> strings.clientsTitle
    HavnDestination.Leads -> strings.navLeads
    HavnDestination.FollowUps -> strings.navFollow
    HavnDestination.Reports -> strings.navReports
    HavnDestination.Tasks -> "Tasks"
    HavnDestination.Analytics -> "Analytics"
    HavnDestination.Agency -> "Agency"
    HavnDestination.Settings -> strings.navSettings
}
